var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "licence-product flex-row" }, [
    _c("span", { staticClass: "licence-product-title bold" }, [
      _vm._v(_vm._s(_vm.product.title))
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "flex-column licence-product-inner" },
      [
        _c(
          "div",
          { staticClass: "flex-column-reverse flex-column ov-reset" },
          _vm._l(_vm.paidLicences, function(pricing, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass:
                  "licence-product-row flex-row ai-center px-3 prelative",
                class: { "mb-3": index !== 0 }
              },
              [
                _c("QuantityProduct", {
                  attrs: {
                    price: pricing,
                    isSaleUser: _vm.isSaleUser,
                    product: _vm.value,
                    freeLicences: _vm.freeLicences,
                    saleLimitation: _vm.saleLimitation
                  },
                  on: {
                    update: function(val) {
                      return _vm.update(val, index)
                    }
                  }
                }),
                _vm._v(" "),
                _vm.isSaleUser
                  ? [
                      _c(
                        "el-tooltip",
                        {
                          attrs: {
                            disabled:
                              _vm.currentProductPlan.amountInCents !==
                              pricing.unit_amount,
                            placement: "bottom-start"
                          }
                        },
                        [
                          _c("span", {
                            attrs: { slot: "content" },
                            domProps: { innerHTML: _vm._s(_vm.amountLabel) },
                            slot: "content"
                          }),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticClass: "licence-product-amount ml-3",
                              attrs: {
                                disabled:
                                  _vm.currentProductPlan.amountInCents ===
                                    pricing.unit_amount &&
                                  pricing.up_to === "inf"
                              },
                              on: { change: _vm.emit },
                              model: {
                                value: pricing.unit_amount,
                                callback: function($$v) {
                                  _vm.$set(pricing, "unit_amount", $$v)
                                },
                                expression: "pricing.unit_amount"
                              }
                            },
                            _vm._l(_vm.allowedAmounts, function(amount) {
                              return _c("el-option", {
                                key: amount.amount,
                                attrs: {
                                  disabled:
                                    _vm.disableAmount(amount.amount) &&
                                    amount.amount !== pricing.unit_amount,
                                  label: amount.label,
                                  value: amount.amount
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ]
                  : _c("span", { staticClass: "ml-4 fs-3 semibold" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("numberformatWithOptions")(
                            _vm._f("floatNumber")(
                              _vm.getPriceAmountByMonth(pricing.unit_amount)
                            ),
                            _vm.numformat,
                            false
                          )
                        )
                      )
                    ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    class: {
                      "ml-2": _vm.isSaleUser,
                      "semibold ml-1": !_vm.isSaleUser
                    }
                  },
                  [
                    _vm._v("€"),
                    _c("span", { staticClass: "fs-2 regular" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("/mois")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.freeLicences.qt && index === _vm.paidLicences.length - 1
                  ? _c(
                      "el-tag",
                      {
                        staticClass:
                          "bold uppercase licence-free-tag pabsolute side-element",
                        attrs: {
                          effect: "dark",
                          type: "success",
                          "disable-transitions": "",
                          size: "mini"
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.labelFreeLicences) +
                            "\n                "
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                index !== _vm.paidLicences.length - 1 && _vm.isSaleUser
                  ? _c(
                      "el-tooltip",
                      {
                        attrs: {
                          content: _vm.$t.__(
                            "pages.account.LicenceProduct.delete_step"
                          ),
                          placement: "bottom-start"
                        }
                      },
                      [
                        _c("CompassIconButton", {
                          ref: "delete-step",
                          refInFor: true,
                          staticClass:
                            "side-element hover-primary-05-bkg transparent-bkg gray-100 b-0 delete-price pabsolute grey",
                          attrs: { size: "medium", icon: "bin" },
                          on: {
                            click: function($event) {
                              return _vm.deleteLevel(pricing)
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              2
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm.isSaleUser
          ? _c("CompassLink", {
              ref: "add-step",
              staticClass: "ml-3 mt-2",
              attrs: {
                label: _vm.$t.__("common.actions.add_step"),
                type: "primary",
                size: "medium",
                prefixIcon: "plus"
              },
              on: { click: _vm.addLevel }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.isSaleUser && _vm.licencesBeDeleted
          ? _c(
              "card",
              {
                ref: "warn-delete-licence",
                staticClass: "mt-3",
                attrs: { background: "warning-05", borderColor: "warning-50" }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$l10n.__(
                        "Vous êtes sur le point de supprimer une ou plusieurs licences attribuées."
                      )
                    ) +
                    "\n            "
                ),
                _c("br"),
                _vm._v(
                  "\n            " +
                    _vm._s(
                      _vm.$l10n.__(
                        "En continuant, le ou les derniers utilisateurs se verront retirer leurs licences."
                      )
                    ) +
                    "\n        "
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.isSaleUser
          ? _c("div", { staticClass: "gray-0-bkg p-3 mt-3 br" }, [
              _c(
                "div",
                { staticClass: "flex-row jc-space" },
                [
                  _c(
                    "span",
                    {
                      staticClass: "semibold block",
                      class: { "mb-3": _vm.showFree }
                    },
                    [_vm._v(_vm._s(_vm.$l10n.__("Licence offerte")))]
                  ),
                  _vm._v(" "),
                  _c("el-switch", {
                    ref: "switch-free",
                    attrs: {
                      "inactive-color": "#565665",
                      "active-color": "#39CF86"
                    },
                    on: { change: _vm.handleFreeLicences },
                    model: {
                      value: _vm.showFree,
                      callback: function($$v) {
                        _vm.showFree = $$v
                      },
                      expression: "showFree"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.showFree
                ? _c(
                    "div",
                    { staticClass: "flex-row ai-center flex-1" },
                    [
                      _c("el-input-number", {
                        staticClass: "licence-product-quantity",
                        attrs: { "step-strictly": "", min: 0 },
                        on: { change: _vm.updateFree },
                        model: {
                          value: _vm.freeLicences.qt,
                          callback: function($$v) {
                            _vm.$set(_vm.freeLicences, "qt", $$v)
                          },
                          expression: "freeLicences.qt"
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "ml-4" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.getPriceAmountByMonth(
                                _vm.basePriceFreeLicence / 100
                              )
                            ) +
                            " €"
                        ),
                        _c("span", { staticClass: "fs-2" }, [
                          _vm._v(_vm._s(_vm.$l10n.__("/mois")))
                        ])
                      ])
                    ],
                    1
                  )
                : _vm._e()
            ])
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }